export default "__VITE_ASSET__DoePwDbU__"